import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import createContextUtilities from '../../utils/createContextUtilities/75e5580757e6f68807f92e07850cfc0605a5ff6677179fbc573cffe4ac0a5df9.cfe-internal.js';

var _createContextUtiliti = createContextUtilities(),
  LogicEditorContextProvider = _createContextUtiliti.Provider,
  useLogicEditorContext = _createContextUtiliti.useContext;

export { LogicEditorContextProvider, useLogicEditorContext };
